<div class="modal">
    <h2>{{ 'medicalHistory.doctorDetailsModal.attending_physician' | translate }}</h2>
    @if(!isEditing){
        <div class="text-container" nz-row>
          <div  nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12">
            <p class="subtitle">{{ 'medicalHistory.doctorDetailsModal.name' | translate }}</p>
            <p>{{ doctorDetails.name }}</p>
          </div>
          <div  nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="11" nzXl="11">
            <p class="subtitle">{{ 'medicalHistory.doctorDetailsModal.surname' | translate }}</p>
            <p> {{ doctorDetails.surname }}</p>
          </div>
        </div>
        <div class="text-container" nz-row>
          <div  nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24">
            <p class="subtitle">{{ 'medicalHistory.doctorDetailsModal.address' | translate }}</p>
            <p> {{ doctorDetails.address }}</p>
          </div>
        </div>
        <div class="text-container" nz-row>
          <div  nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12">
            <p class="subtitle">{{ 'medicalHistory.doctorDetailsModal.telephone' | translate }}</p>
            <p>{{ doctorDetails.phone }}</p>
        </div>
        <div  nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="11" nzXl="11">
          <p class="subtitle">{{ 'medicalHistory.doctorDetailsModal.email' | translate }}</p>
          <p> {{ doctorDetails.mail }}</p>
        </div>
      </div>

      <div class="button-container">
        <ds-button
                class="button-edit"
                [text]="'buttons.edit' | translate"
                [styleType]="'empty-main'"
                [width]="'small'"
                (click)="startEditing()"
                ></ds-button>

                <ds-button
                class="button-exit"
                [text]="'buttons.exit' | translate"
                [width]="'small'"
                [isDisabled]="false"
                (click)="close()"
        ></ds-button>
      </div>
    }
    @if(isEditing){
      <form [formGroup]="editForm">
        <div class="text-container" nz-row>
          <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12">
            <ds-input-text
            nz-col
            [type]="'text'"
            [nzLg]="12"
            [nzXs]="24"
            [nzMd]="12"
            [control]="editForm.get('name')"
            [placeholder]="'medicalHistory.doctorDetailsModal.name' | translate"
            [label]="'medicalHistory.doctorDetailsModal.name' | translate"
          ></ds-input-text>
          </div>
          <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="11" nzXl="11">
            <ds-input-text
          nz-col
          [type]="'text'"
          [nzLg]="12"
          [nzXs]="24"
          [nzMd]="12"
          [control]="editForm.get('surname')"
          [placeholder]="'medicalHistory.doctorDetailsModal.surname' | translate"
          [label]="'medicalHistory.doctorDetailsModal.surname' | translate"
        ></ds-input-text>
          </div>
        </div>
        <div class="text-container" nz-row>
          <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24">
            <ds-input-text
            nz-col
            [type]="'text'"
            [nzLg]="12"
            [nzXs]="24"
            [nzMd]="12"
            [control]="editForm.get('address')"
            [placeholder]="'medicalHistory.doctorDetailsModal.address' | translate"
            [label]="'medicalHistory.doctorDetailsModal.address' | translate"
          ></ds-input-text>
          </div>
        </div>
        <div class="text-container" nz-row>
          <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12">
            <ds-input-text
            nz-col
            [type]="'text'"
            [nzLg]="12"
            [nzXs]="24"
            [nzMd]="12"
            [control]="editForm.get('phone')"
            [placeholder]="'medicalHistory.doctorDetailsModal.telephone' | translate"
            [label]="'medicalHistory.doctorDetailsModal.telephone' | translate"
          ></ds-input-text>
          </div>
          <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="11" nzXl="11">
            <ds-input-text
            nz-col
            [type]="'text'"
            [nzLg]="12"
            [nzXs]="24"
            [nzMd]="12"
            [control]="editForm.get('mail')"
            [placeholder]="'medicalHistory.doctorDetailsModal.email' | translate"
            [label]="'medicalHistory.doctorDetailsModal.email' | translate"
          ></ds-input-text>
          </div>
        </div>
        <div class="button-container">
          <ds-button
            class="button-exit"
            [text]="'buttons.exit' | translate"
            [styleType]="'empty-main'"
            [width]="'small'"
            (click)="closeEditing()"
          ></ds-button>
          <ds-button
            class="button-save"
            [text]="'buttons.save' | translate"
            [width]="'small'"
            (click)="saveDoctorDetail()"
          ></ds-button>
        </div>
      </form>
    }
</div>
